import * as React from "react";
import {css, cx} from "emotion";

import "./left-nav-item-dropdown-default.scss";

import {ActiveWheel}    from "@Common/react/active-wheel";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";

import {MenuInternalLink} from "../../../../common/components/internal-link";
import {getAbsLink}       from "../../../../common/get-abs-link";

export const LnidDefault = ({items, left, navBlock=undefined}) => cs(
    consumeContext("themeScheme"),
    consumeContext("editor"),
    ({themeScheme, editor}) => (
        <ActiveWheel
            className="lnid-default-4fjd" style={{paddingLeft: left - (editor?.value ? 330 : 0)}}
            onWheel={(e) => e.preventDefault()}
        >
            {items.map((item, i) => cs(
                keyed(i),
                () => (
                    item?.type === "internalUrl" ? (
                        MenuInternalLink({
                            to: item?.link,
                            className: cx("item-ov1", css`
                                color: ${themeScheme.xpresso.menuTextColor} !important;
                                &:hover {
                                    // color: white;
                                }
                            `),
                            "xd-qa-type": "link",
                            "xd-qa-name": item.linkLabel || item?.child?.[0]?.name,
                            navBlock,
                            children: <>
                                {item?.icon && (
                                    <div
                                        className="img"
                                        style={{
                                            backgroundImage: `url(${item?.icon})`,
                                        }}
                                    />
                                )}
                                {item.linkLabel || item?.child?.[0]?.name}
                            </>,
                        })
                    ) : (
                        <a
                            href={getAbsLink(item.link)}
                            className={cx("item-ov1", css`
                            color: ${themeScheme.xpresso.menuTextColor} !important;
                                &:hover {
                                    // color: white;
                                }
                            `)}
                            xd-qa-type="link"
                            xd-qa-name={item.linkLabel}
                            onClick={async (e) => {
                                e.preventDefault();
                                if (await navBlock?.block() === true) {
                                    return;
                                }
                                window.location.href = getAbsLink(item.link);
                            }}
                        >
                            {item.linkLabel}
                        </a>
                    )
                ),
            ))}
        </ActiveWheel>
    )
);